<template>
  <div class="selected-color">
    <p class="selected-color-text">
      文字色: {{ characterColor.name }}
    </p>
    <div
      class="selected-color-icon"
      :style="{ backgroundColor: characterColor.colorCode }"
    />
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    characterColor: {
      type: Object,
      default: () => ({ name: "白", colorCode: "white" }),
    },
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.selected-color {
  display: flex;
  flex: 1;
  text-align: center;
  font-weight: bold;
  justify-content: center;
  align-items: center;

  &-text {
    margin: 0;
  }

  &-icon {
    height: 12px;
    width: 12px;
    margin-left: 10px;
    border: 2px solid black;
    background-attachment: yellow;
  }
}
</style>
